import * as React from "react";

export const IconDownloadBlue = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_20165_15116)">
    <path d="M16.3327 7.5H12.9993V2.5H7.99935V7.5H4.66602L10.4993 13.3333L16.3327 7.5ZM4.66602 15V16.6667H16.3327V15H4.66602Z" fill= {props.color}/>
    </g>
    <defs>
    <clipPath id="clip0_20165_15116">
    <rect width="20" height="20" fill="white" transform="translate(0.5)"/>
    </clipPath>
    </defs>
  </svg>
);
